export const apificate = state => {
  return state.publicSectorInformation.publicOrganismCode || state.buyerCentres.receiverAdministrativeCentre.code ? state : null
}
